import { Card, Radio } from "antd";
import React, { useContext, useState } from "react";
import useAsyncEffect from "use-async-effect";
import reportService from "../../../../../../services/report.service";
import { LayoutContext } from "../../../../../providers/layout";
import PieChart from "../../../../../shared/pie-chart/pie-chart";
import "../../../home.scss";

const OrdersByLocation: React.FC = () => {
  const { setLoading } = useContext(LayoutContext);
  const [data, setData] = useState<any[]>([]);
  const [period, setPeriod] = useState("30");

  useAsyncEffect(async () => {
    setLoading(true);
    const response = await reportService.getOrdersByLocation(period);
    setData(response);
    setLoading(false);
  }, [period]);

  return (
    <Card className="dashboard-card">
      <div className="widget-header">
        <span className="widget-title">Orders by Location</span>

        <Radio.Group
          className="segment-control"
          value={period}
          size="small"
          onChange={(e) => setPeriod(e.target.value)}
        >
          <Radio.Button value="1">Day</Radio.Button>
          <Radio.Button value="7">Week</Radio.Button>
          <Radio.Button value="30">Month</Radio.Button>
          <Radio.Button value="all">All</Radio.Button>
        </Radio.Group>
      </div>

      <div className="chart-container">
        <PieChart data={data} />
      </div>
    </Card>
  );
};

export default OrdersByLocation;
